// extracted by mini-css-extract-plugin
module.exports = {"small":"typography-module--small--20lGn","medium":"typography-module--medium--19Y11","large":"typography-module--large--3cEBV"};